module.exports = __webpack_public_path__ + "static/media/icon-menu-up.92ca93a7.svg";